import { bexHttpClient } from '../../clients';

/**
 * WhatsApp Co-existence (Meta Cloud API via the wamcp001 gateway) operations that
 * are neither channel CRUD nor Baileys bridge calls.
 *
 * Route: /cm/whatsapp/coexistence/* on BeX Server, which forwards to FEO over the
 * service-key channel. The browser never holds the FEO service key, and never sees
 * the number's signing secret on the way back out — FEO reads it off the channel.
 */
class CoexistenceService {
    /**
     * Point the gateway at our webhook for this number, so Meta has somewhere to
     * deliver. Must run AFTER the channel exists: FEO reads the signing secret and
     * the Meta Phone Number ID off the channel record.
     *
     * `callback_url` is passed explicitly rather than derived server-side because
     * FEO's public host is not something the platform can infer; the response echoes
     * back the URL actually registered so the UI can show what Meta will hit.
     */
    async registerCallback(
        organizationId: string,
        data: { address: string; callback_url: string },
    ): Promise<any> {
        return bexHttpClient.post(
            `/whatsapp/coexistence/register-callback/${organizationId}`,
            data,
        );
    }
}

const coexistenceService = new CoexistenceService();
export { coexistenceService };
